<template>
  <!-- 头部 -->
  <div class="header-title">
    <div class="hLeft">
      <img
        src="../../assets/sy/1.png"
        alt=""
        style="height: 35px; margin: auto"
      />
    </div>
    <div class="hRight">
      <el-menu
        router
        mode="horizontal"
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        style="text-align: center; margin-top: 10px;"
        active-text-color="#409EFF"
      >
        <el-menu-item
          v-for="(item, index) in nav"
          :index="item.url"
          :key="index"
        >
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </div>

    <el-dialog
      title="欢迎登录"
      :visible.sync="centerDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="27rem"
      :append-to-body="true"
      center
    >
      <el-form
        style="margin-top: 1rem"
        ref="form"
        :model="Loginform"
        label-width="70px"
      >
        <el-form-item label="手机号">
          <el-input
            style="width: 285px"
            v-model="Loginform.username"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            style="width: 285px"
            :type="passw"
            v-model="Loginform.password"
            placeholder="请输入密码"
          >
            <i slot="suffix" :class="icon" @click="showPass"></i
          ></el-input>
        </el-form-item>

        <el-form-item style="margin-left: -50px; margin-top: -20px">
          <el-checkbox
            v-model="Loginform.remembeL"
            label="记住登录密码"
            name="type"
          ></el-checkbox>
          <span style="float: right; margin-right: 20px">
            <el-button
              type="text"
              @click="(wjDialogVisible = true), (centerDialogVisible = false)"
              >忘记密码？</el-button
            >
          </span>
        </el-form-item>
        <el-form-item style="margin-left: -50px; margin-top: 40px">
          <el-button type="primary" style="width: 100%" @click="loginUser"
            >登录</el-button
          >
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <span>
            <el-button
              type="text"
              @click="(yzmDialogVisible = true), (centerDialogVisible = false)"
              >短信验证码登录</el-button
            >
          </span>
          <span style="float: right">
            没有账号？<el-button
              type="text"
              @click="(zcDialogVisible = true), (centerDialogVisible = false)"
              >立即注册</el-button
            >
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 短信验证码 -->
    <el-dialog
      title="欢迎登录"
      :visible.sync="yzmDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="27rem"
      :append-to-body="true"
      center
    >
      <el-form
        style="margin-top: 1rem"
        ref="messageForm"
        :model="messageForm"
        label-width="70px"
      >
        <el-form-item label="手机号">
          <el-input
            style="width: 285px"
            v-model="messageForm.username"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input
            v-model="messageForm.verification"
            style="width: 285px"
            placeholder="请输入验证码"
          >
            <template slot="append" style="background-color: #fff">
              <el-button
                v-if="canClick1 === false"
                style="width: 120px"
                type="primary"
                class="buttonss"
                @click="finnbacks1()"
              >
                发送验证码
              </el-button>
              <el-button
                v-if="canClick1"
                class="buttons"
                style="background: #fff; color: #b8b8b8; width: 120px"
              >
                {{ totalTime1 }}s后重新发送
              </el-button>
            </template></el-input
          >
        </el-form-item>
        <el-form-item style="margin-left: -40px">
          <el-checkbox v-model="checkeddx">下次自动登录</el-checkbox>
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <el-button type="primary" style="width: 100%" @click="loginyzm"
            >登录</el-button
          >
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <span>
            <el-button
              type="text"
              @click="(yzmDialogVisible = false), (centerDialogVisible = true)"
              >账号密码登录</el-button
            >
          </span>
          <span style="float: right">
            没有账号？<el-button
              type="text"
              @click="(zcDialogVisible = true), (yzmDialogVisible = false)"
              >立即注册</el-button
            >
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 注册 -->
    <el-dialog
      title="欢迎注册"
      :visible.sync="zcDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="27rem"
      :append-to-body="true"
      center
    >
      <el-form
        style="margin-top: 1rem"
        ref="registerForm"
        :model="registerForm"
        label-width="70px"
      >
        <el-form-item label="手机号">
          <el-input
            style="width: 285px"
            v-model="registerForm.username"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input
            v-model="registerForm.verification"
            style="width: 285px"
            placeholder="请输入验证码"
          >
            <template slot="append" style="background-color: #fff">
              <el-button
                v-if="canClick === false"
                style="width: 120px"
                type="primary"
                class="buttonss"
                @click="finnbacks()"
              >
                发送验证码
              </el-button>
              <el-button
                v-if="canClick"
                class="buttons"
                style="background: #fff; color: #b8b8b8; width: 120px"
              >
                {{ totalTime }}s后重新发送
              </el-button>
            </template></el-input
          >
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            style="width: 285px"
            :type="passw"
            v-model="registerForm.password"
            auto-complete="new-password"
            placeholder="请输入密码"
          >
            <i slot="suffix" :class="icon" @click="showPass"></i
          ></el-input>
        </el-form-item>
        <el-form-item label="学校">
          <el-select
            style="width: 92%"
            v-model="registerForm.XXvalue"
            placeholder="请选择学校"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: -40px">
          <el-checkbox v-model="checkedxy"
            >我已阅读并接受
            <el-button type="text"> 用户协议</el-button>和<el-button type="text"
              >隐私政策</el-button
            ></el-checkbox
          >
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <el-button
            type="primary"
            style="width: 100%"
            @click="loginRegistration('registerForm')"
            >注册</el-button
          >
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <span style="float: right">
            已有账号？<el-button
              type="text"
              @click="(zcDialogVisible = false), (centerDialogVisible = true)"
              >立即登录</el-button
            >
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 忘记密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="wjDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="27rem"
      :append-to-body="true"
      center
    >
      <el-form
        style="margin-top: 1rem"
        ref="xgpassForm"
        :model="xgpassForm"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="手机号">
          <el-input
            style="width: 285px"
            v-model="xgpassForm.username"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input
            v-model="xgpassForm.verification"
            style="width: 285px"
            placeholder="请输入验证码"
          >
            <template slot="append" style="background-color: #fff">
              <el-button
                v-if="canClick2 === false"
                style="width: 120px"
                type="primary"
                class="buttonss"
                @click="finnbacks2()"
              >
                发送验证码
              </el-button>
              <el-button
                v-if="canClick2"
                class="buttons"
                style="background: #fff; color: #b8b8b8; width: 120px"
              >
                {{ totalTime2 }}s后重新发送
              </el-button>
            </template></el-input
          >
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            style="width: 285px"
            v-model="xgpassForm.password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password1">
          <el-input
            style="width: 285px"
            v-model="xgpassForm.password1"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -50px">
          <el-button type="primary" style="width: 100%" @click="loginUpdate"
            >确认修改</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import WOW from "wowjs";
import Cookies from "js-cookie";
export default {
  name: "headertitle",
  data() {
    return {
      lxwxShow: true,
      centerDialogVisible: false,
      zcDialogVisible: false,
      yzmDialogVisible: false,
      wjDialogVisible: false,
      longinxs: 1,
      Loginform: {
        username: "",
        password: "",
        remembeL: false,
      },
      registerForm: {
        username: "",
        password: "",
        verification: "",
        XXvalue: "",
      },
      messageForm: {
        username: "",
        verification: "",
      },
      xgpassForm: {
        username: "",
        verification: "",
        password: "",
        password1: "",
      },
      //用于改变Input类型
      passw: "password",
      //用于更换Input中的图标
      icon: "el-input__icon el-icon-view",
      options: [],
      totalTime: 60,
      totalTime1: 60,
      totalTime2: 60,
      canClick: false, // 添加canClic,
      canClick1: false,
      canClick2: false,
      checkedxy: false,
      checkeddx: false,
      nav: [
        {
          title: "首页",
          url: "/hyxw",
        },
        {
          title: "公司简介",
          url: "/gsjj",
        },
        {
          title: "信息动态",
          url: "/hyxw1",
        },
        {
          title: "联系我们",
          url: "/ContactUs",
        },
      ],
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password1: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCookie();
  },
  mounted() {
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: false,
        live: true,
      });
      wow.init();
    }, 200);
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  methods: {
    goLxwm(item) {
      this.$store.commit("zxxixvt", "");
      this.$router.push({ name: "ContactUs", params: { lx: item } }, () => {});
      this.$store.commit("zxxixvt", item);
    },
    folatShow() {
      this.lxwxShow = false;
    },
    // getselfaculty() {
    //   selfaculty().then((res) => {
    //     this.options = res;
    //     this.options.unshift({ id: 11, name: "其他" });
    //   });
    // },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const remembeL = Cookies.get("remembeL");
      this.Loginform = {
        username: username === undefined ? this.Loginform.username : username,
        password: password === undefined ? this.Loginform.password : password,
        remembeL: remembeL === undefined ? false : Boolean(remembeL),
      };
    },
    //修改密码
    loginUpdate() {
      let data = new FormData();
      data.append("phone", this.xgpassForm.username);
      data.append("mobile_code", this.xgpassForm.verification);
      finnbnoteverifyack(data).then((res) => {
        if (res.code == "OK") {
          let data1 = new FormData();
          data1.append("phone", this.xgpassForm.username);
          if (this.xgpassForm.password == this.xgpassForm.password1) {
            data1.append("password", this.xgpassForm.password);
          } else {
            return this.$message({
              message: "两次密码不一致",
              type: "error",
            });
          }

          thepassword(data1).then((res) => {
            if (res.code == "OK") {
              this.$message({
                message: "修改密码成功",
                type: "success",
              });
              this.wjDialogVisible = false;
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //密码的隐藏和显示
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = "el-input__icon el-icon-view";
      } else {
        this.passw = "text";
        this.icon = "el-input__icon el-icon-loading";
      }
    },
    //登录
    async loginUser() {
      if (this.Loginform.remembeL) {
        Cookies.set("username", this.Loginform.username, { expires: 30 });
        // Cookies.set("password", encrypt(this.Loginform.password), {
        //   expires: 30,
        // });
        Cookies.set("password", this.Loginform.password, {
          expires: 30,
        });
        Cookies.set("remembeL", this.Loginform.remembeL, { expires: 30 });
      } else {
        Cookies.remove("username");
        Cookies.remove("password");
        Cookies.remove("remembeL");
      }
      const thisa = new FormData();
      thisa.append("phone", this.Loginform.username);
      thisa.append("token", "token");
      thisa.append("password", this.Loginform.password);
      await Loginnterface(thisa).then((res) => {
        if (res.code === "OK") {
          this.centerDialogVisible = false;
          this.$message({
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("Token", res.wuser.token);
          this.$store.dispatch("getUser", res.wuser);
          this.$store.commit("userts", res.wuser);
          this.$store.commit("checkToken", true);
          location.reload();
        } else if (res.code === "ERR") {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 判断获取下拉框
    handleCommand(command) {
      if (command === "退出登录") {
        this.LogOut();
      } else if (command === "个人信息") {
        this.$router.push("/personalnav");
      } else if (command === "修改密码") {
        this.wjDialogVisible = true;
        this.xgpassForm.username = this.$store.state.user.phone;
      }
    },
    LogOut() {
      // 退出登录
      localStorage.removeItem("Token");

      this.$store.dispatch("checkToken");
      this.$router.push("/");
    },
    Login(item) {
      if (item == "取消") {
        this.centerDialogVisible = false;
      } else {
        this.centerDialogVisible = true;
      }
    },
    // 验证码
    finnbacks() {
      if (this.registerForm.username == "") {
        this.$message({
          message: "请填写手机号",
          type: "warning",
        });
      } else {
        var data = new FormData();
        data.append("phone", this.registerForm.username);
        Verificationcode(data).then((res) => {
          if (res.code === "OK") {
            this.canClick = true;
            this.countDown();
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      }
    },
    //登录验证码
    finnbacks1() {
      if (this.messageForm.username == "") {
        this.$message({
          message: "请填写手机号",
          type: "warning",
        });
      } else {
        var data = new FormData();
        data.append("phone", this.messageForm.username);
        Verificationcode(data).then((res) => {
          if (res.code === "OK") {
            this.canClick1 = true;
            this.countDown1();
          }
        });
      }
    },
    //修改密码验证码
    finnbacks2() {
      if (this.xgpassForm.username == "") {
        this.$message({
          message: "请填写手机号",
          type: "warning",
        });
      } else {
        var data = new FormData();
        data.append("phone", this.xgpassForm.username);
        passwordcode(data).then((res) => {
          this.canClick2 = true;
          this.countDown2();
        });
      }
    },
    // 验证码倒计时倒计时
    countDown() {
      // this.content = this.totalTime + 's后重新发送' // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime--;
        if (this.totalTime < 0) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.canClick = false;
          this.totalTime = 60;
        }
      }, 1000);
    },
    countDown1() {
      // this.content = this.totalTime + 's后重新发送' // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime1--;
        if (this.totalTime1 < 0) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.canClick1 = false;
          this.totalTime1 = 60;
        }
      }, 1000);
    },
    countDown2() {
      // this.content = this.totalTime + 's后重新发送' // 这里解决60秒不见了的问题
      const clock = window.setInterval(() => {
        this.totalTime2--;
        if (this.totalTime2 < 0) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
          this.canClick2 = false;
          this.totalTime2 = 60;
        }
      }, 1000);
    },
    loginRegistration(formName) {
      if (this.checkedxy == false) {
        return this.$message({
          message: "请勾选用户协议及隐私政策",
          type: "warning",
        });
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const data = new FormData();
            data.append("phone", this.registerForm.username);
            data.append("password", this.registerForm.password);
            data.append("mobile_code", this.registerForm.verification);
            data.append("organization", this.registerForm.XXvalue);
            registered(data).then((res) => {
              if (res.code === "OK") {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.zcDialogVisible = false;
                this.centerDialogVisible = true;
              }
              if (res.code === "ERR") {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "error",
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    //验证码登录
    loginyzm() {
      if (this.checkeddx == true) {
      }
    },
  },
  components: {},
  watch: {},
};
</script>

<style scoped lang="scss">
.header-title {
  width: 90%;
  height: 80px;
  margin: 0 auto;
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  .lxwx {
    background-image: url("../../assets/sy/图层\ 24.png");
    background-size: 100%, 100%;
    background-size: cover;
    float: right;
    position: fixed;
    top: 330px;
    right: 0px;
    width: 205px;
    height: 286px;
    border-radius: 8px;
    z-index: 100;
    .lxwx_title {
      text-align: center;
      margin-top: 25px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 26px;
    }
  }

  .hLeft {
    display: flex;

    .font {
      margin: 0.8rem;
      margin-left: 0.5rem;
      color: #fff;

      .tops {
        font-size: 2rem;
        height: 1.5625rem;
        font-family: PangMenZhengDao;
        font-weight: 400;
        letter-spacing: 0.04rem;
        margin-bottom: 1rem;
      }

      .fo {
        font-size: 1rem;
        height: 0.75rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
  }

  .hRight {
    display: flex;
    margin-right: 3rem;
    color: #fff;

    .username {
      .login {
        display: inline-block;
        position: relative;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        color: black;
        font-weight: 400;
        line-height: 80px;
        margin: auto;
      }

      .el-dropdown {
        display: inline-block;
        position: relative;
        color: #606266;
        font-size: 1rem;
        line-height: 80px;
        margin: auto;
      }

      .el-dropdown-link {
        color: black;
      }
    }
  }
}
</style>
